import React from 'react';
import { Card } from 'reactstrap';
import { PseudoStates, useFetch } from '@cordata/buffet';

import { MatchStatus } from '~/utils/const/identity';
import usePatient from '~/utils/patient/hook';

import ContactCard from '~/components/common/ContactCard';

const Pcp = () => {
  const [, patient] = usePatient();
  const [s, pcps] = useFetch('data/public/list-view-cs-tbl-primaryprovider', {
    params: {
      sacwis_id: patient.sacwisPersonId,
      iscurrentpcp: 'current',
      match_status_id: MatchStatus.Approved,
      sort: '-effdateDt',
      'effdateDt__!': 'null',
      page: 1,
      'page-size': 1,
    },
    instance: 'p',
  });

  return s === 'success'
    ? (pcps?.length > 0) && pcps.map(pcp => (
      <ContactCard
        title="Primary Care Provider"
        name={pcps?.length > 0 ? `${pcp.attributes.firstname} ${pcp.attributes.lastname}` : 'No PCP on record'}
        telephoneNumber={pcps?.length > 0 ? pcp.attributes.phone : ''}
        address={pcps?.length > 0 ? pcp.attributes : undefined}
      />
    ))
    : <Card body><PseudoStates status={s} /></Card>;
};

export default Pcp;
